export const DATA_TRANSFER_PAYLOAD = "payload";

export const MESSAGE_LIVE_TIME = 7000;

export const QTY_DT_PER_PAGE = 25;

/* eslint-disable */
export const emailRegex = /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;

export const GLOBAL_FILTERS_DEFAULT = {
  numTransp: "",
  numCont: "",
  comment: "",
  declarant: "",
  articul: "",
  groupDesc: "",
  goodDesc: "",
  period: 10,
  tnved: "",
  typeDoc: "",
  numDoc: "",
};

export const  LOCAL_FILTERS_DEFAULT = {
  anyvalue: "",
  statuses: [],
  procedures: [],
};
